
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class DefaultHelp extends Vue {
  @Prop(String) public message!: string;

}
